module.exports = __webpack_public_path__ + "img/chart_bg2.08411b9a.png";